<script setup lang="ts">
import { computed, nextTick, onMounted, useTemplateRef, watch } from 'vue';
import type { FieldSchema } from '../../../types';

const emits = defineEmits<{
  change: [value: string | undefined];
}>();

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    error?: string;
    field?: FieldSchema;
    isInlineEditing?: boolean;
    isResultsField?: boolean;
    placeholder?: string;
    required?: boolean;
  }>(),
  {
    isInlineEditing: false,
    isResultsField: false,
    placeholder: 'components.forms.placeholder.common',
  }
);

const model = defineModel<string>();

const inlineComponentRef = useTemplateRef<any>('inlineComponentRef');

const settings = computed(() => props?.field?.settings);
const _disabled = computed(() => {
  if (props.field?.state?.disabled) return props.field?.state.disabled;

  return settings.value?.editable ? !settings.value?.editable : props.disabled;
});

onMounted(() => checkEditType());

watch(model, () => onSelectValue());

function checkEditType() {
  if (!props.isInlineEditing || !inlineComponentRef.value) return;

  nextTick(() => {
    inlineComponentRef.value.$el.focus();
  });
}

function onSelectValue() {
  if (!props.isResultsField) return;

  emits('change', model.value);
}
</script>

<template>
  <InputText
    v-model="model"
    ref="inlineComponentRef"
    :class="['h-9 w-full text-sm', { 'af-field-error': !!error }]"
    :disabled="_disabled"
    :invalid="!!error"
    :placeholder="$t(settings?.placeholder || placeholder)"
    :required="settings?.required || required"
  />
</template>
